import React from 'react';
import "../style/About.css";
import Certificate from './Certificate';

const About = () => {
  return (
    <>
      <div className='about'>
        <h1>About Us</h1>

        <div className='about_content'>
          <p>At SVP Packaging, we don’t just create packaging—
            we craft experiences. For over a decade, we’ve
            delivered innovative, sustainable, and customized
            solutions across industries like Automotive,
            Cosmetics, E-commerce, FMCG, Pharma, Retail,
            and Textiles. Our commitment to challenging the
            status quo and pushing the boundaries of design sets
            us apart. We focus on high-quality, durable
            packaging that elevates your brand, using advanced
            technology and a passion for innovation to ensure
            your packaging stands out and delivers excellence
            every time.
          </p>

          <div className='about_img'>
            <div id='about_img'>

            </div>
          </div>
        </div>
      </div>
      <Certificate />
    </>
  );
};

export default About;
